import MultipleClientsTable from './MultipleClientsTable';

export default MultipleClientsTable;


// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/multiple-clients-table/index.js